$(() => {
  const $video = $('.hero-embed__video');

  if (!$video.length) {
    return;
  }

  const video = $video.get(0) as HTMLVideoElement;

  video.setAttribute('playsinline', 'true');
  video.setAttribute('webkit-playsinline', 'true');
  video.muted = true;
  video.autoplay = true;

  const preventFullscreen = () => {
    const webkitVideo = video as HTMLVideoElement & { webkitExitFullscreen?: () => void };

    if (typeof webkitVideo.webkitExitFullscreen === 'function') {
      webkitVideo.webkitExitFullscreen();
    }
  };

  video.addEventListener('webkitbeginfullscreen', preventFullscreen);
  video
    .play()
    .then(() => {})
    .catch(() => {});
});
